export const catalog = {
  title: "Catalog",
  description: "Products, work centres, and materials that feed quoting and planning.",
  buttons: {
    workCenter: "Work centre",
    material: "Material",
    product: "Product",
  },
  sections: {
    workCenters: "Work centres",
    materials: "Materials",
    products: "Products",
  },
  column: {
    code: "Code",
    name: "Name",
    hourlyRate: "Hourly rate",
    sku: "SKU",
    unit: "Unit",
    standardCost: "Standard cost",
    revision: "Revision",
    actions: "Actions",
  },
  revision: {
    released: "Released",
    noRevision: "No revision",
    addRevision: "Add revision",
  },
  workCenter: {
    addTitle: "Add a work centre",
    saved: "Save work centre",
    addedToast: "Work centre added",
    rateHint: "Used to estimate work-centre time.",
  },
  material: {
    addTitle: "Add a material",
    saved: "Save material",
    addedToast: "Material added",
    costHint: "Per unit, used for estimating.",
  },
  product: {
    addTitle: "Add a product",
    saved: "Save product",
    addedToast: "Product added",
  },
  productRevision: {
    title: "Create a product revision",
    description: "Routings and bill of materials seed quote estimates for this product.",
    releaseRevision: "Release revision",
    releasedToast: "Revision released",
    routing: "Routing",
    addStep: "Add step",
    none: "None",
    stepDescription: "Step description",
    setupMin: "Setup (min)",
    runMinPerUnit: "Run min per unit",
    bom: "Bill of materials",
    addMaterial: "Add material",
    qtyPerUnit: "Qty per unit",
    scrapFactor: "Scrap factor",
  },
};
